import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import AccountCreation from "@/components/signup/account-creation";
import {
    JiraOverlayTemplate,
    WhiteScreenInput,
    WhiteScreenLayout,
    WhiteScreenSocial,
    WhiteScreenSubmit
} from "@/components/signup/layouts";
import { wacToken } from "@/libraries/design/foundations";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { GetStartedHeading, InputSubmitButton } from "../../../components";

export const LoggedOutJiraPremium = () => {
    const intl = useIntl();
    const heading1 = intl.formatMessage(
        {
            id: "BxpUiSignup.SignupForm.header",
            defaultMessage: "Get started with {product}"
        },
        { product: "Jira" }
    );

    const heading2 = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.subheader.jsw.premium",
        defaultMessage:
            "30-day free trial for unlimited users on the Premium plan — no credit card needed"
    });

    const overlayAppearance = checkFeatureFlagGate(
        featureFlags.migrateLoggedOutJiraPaidSignupToOverlay
    );

    if (overlayAppearance) {
        return (
            <JiraOverlayTemplate size="sm">
                <GetStartedHeading productName="Jira" />
                <p css={subHeaderCss}>{heading2}</p>
                <AccountCreation Input={<InputSubmitButton />} Submit={null} />
            </JiraOverlayTemplate>
        );
    }

    return (
        <WhiteScreenLayout heading1={heading1} heading2={heading2}>
            <AccountCreation
                Input={<WhiteScreenInput />}
                Social={<WhiteScreenSocial />}
                Submit={<WhiteScreenSubmit />}
            />
        </WhiteScreenLayout>
    );
};

const subHeaderCss = css({
    color: wacToken("color.primary.black"),
    margin: "0 0 24px",
    textAlign: "center"
});
